define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 演示子项执行动作条件类型。
     *
     * @exports EnumConditionType
     * 
     * @see PresentationItem#condition
     */
    var EnumConditionType = {
        /**
         * 立即触发。
         * @type {Number}
         * @constant
         */
        IMMEDIATE: 1,

        /**
         * 等待。
         * @type {Number}
         * @constant
         */
        WAIT: 2,

        /**
         * 阻塞。
         * @type {Number}
         * @constant
         */
        BLOCK: 3
    }
    freezeObject(EnumConditionType)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumConditionType) {
            if (EnumConditionType.hasOwnProperty(key) && EnumConditionType[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        IMMEDIATE: 1,
        WAIT: 2,
        BLOCK: 3,
        getName: getName
    }
})